import '@src/base/index.styl';
import '@src/app.styl';
import { useEffect } from 'react';
import { I18nProvider } from '@src/base/providers/i18n';
import analyticsService from '@src/base/services/analytics';
import urlService from '@src/base/services/url';
import { setInitialTheme } from '@src/base/services/theme';
import { Router } from '@src/router';

export const App = () => {
  useEffect(() => {
    setInitialTheme();
    handleLoadingCssClassRemoval();
    analyticsService.init();
  }, []);

  return (
    <I18nProvider>
      <Router />
    </I18nProvider>
  );
};

function handleLoadingCssClassRemoval(){
  const params = urlService.getSearchParams();
  if(params.prerender !== 'true') {
    document.body.classList.remove('is-loading');
  }
}
